export const changeStateNameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_STATE_NAME":
      return action.payload.stateName;
    default:
      return state;
  }
};
